import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { FeatureFlag } from "PFCore/types/feature_flag";
import { CurrentAccount } from "PFTypes";
import { useMemo } from "react";

export const isFeatureEnabled =
  (account: CurrentAccount | null): ((feature: FeatureFlag) => boolean) =>
  (name) => {
    const features = account && account.active_features;
    return !!(features && features.filter((feature) => feature.name === name).length > 0);
  };

export default function useIsFeatureEnabled(): (feature: FeatureFlag) => boolean;
export default function useIsFeatureEnabled(feature: FeatureFlag): boolean;
export default function useIsFeatureEnabled(
  feature?: FeatureFlag
): ((feature: FeatureFlag) => boolean) | boolean {
  const { data: currentAccount } = useCurrentAccount();

  return useMemo(() => {
    const checkFeatureStatus = currentAccount && isFeatureEnabled(currentAccount);

    return feature ? checkFeatureStatus?.(feature) : checkFeatureStatus;
  }, [currentAccount, feature]);
}
